"use client";

import Link from "next/link";


export default function PageInfoLoadError() {

    return (
        <section>

            <div className="w-full font-poppins text-2xl text-center">{"Erro ao carregar Informação da página"}</div>
            <div className="w-full font-poppins text-2xl text-center p-10">
                <Link href="#" onClick={()=>"js:window.location.reload();"} className="bg-red-500 px-2 py-2 text-white rounded-xl" style={{color:"#fffff !important"}} >Recarregar</Link>
            </div>
        </section>
    );
};